import { useQuery } from 'react-query';
import FloorPlanService from '../../../../services/floorPlanService';

const floorPlanService = new FloorPlanService();

export const useFloorPlansForSelectFromWaitlistQuery = (
  organizationId,
  propertyId,
  options = {},
) =>
  useQuery(
    ['floorPlans', organizationId, propertyId],
    () => floorPlanService.getAll(organizationId, propertyId, {}),
    {
      enabled: Boolean(organizationId && propertyId),
      select: (data) => data || [],
      ...options,
    },
  );
